// React import not needed in React 19+ with new JSX transform
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import type { FieldConfig } from "../types";

interface BooleanFieldProps<T> {
  field: FieldConfig<T>;
  value: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
  id: string;
}

export function BooleanField<T>({
  field,
  value,
  onChange,
  disabled,
  id,
}: BooleanFieldProps<T>) {
  return (
    <div className="flex items-center space-x-2">
      <Checkbox
        id={id}
        checked={value || false}
        onCheckedChange={(checked) => onChange(!!checked)}
        disabled={disabled}
        aria-required={field.required || undefined}
        data-testid={field.testid}
      />
      <Label htmlFor={id} className="text-sm font-normal">
        {field.description || field.label}
      </Label>
    </div>
  );
}
